import React from "react";
import CmModal from "../../../../../components/CmModal/CmModal";
import BaseComponent from "../../../../../base/BaseComponent";
import CmTree from "../../../../../components/CmTree/CmTree";
import {generateTreeData, treeForEach} from "../../../../../utils";
import {Icon} from "antd";

export default class BoundPermissionModal extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            treeData: [],
            autoExpandParent: false,
            checkedKeys: [],
            expandedKeys: []
        };
    }

    componentDidMount() {
        this.setTreeData();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.visible&&this.props.visible !== prevProps.visible) {
            this.setState({
                checkedKeys: []
            });
            this.setTreeData();
        }
    }

    render() {
        const {
            visible
        } = this.props;
        let {
            treeData,
            expandedKeys,
            autoExpandParent,
            checkedKeys
        } = this.state;
        return (
            <CmModal
                title="绑定权限"
                visible={visible}
                handleCancel={this.handleCancel}
                handleOk={this.handleOk}
                width={400}
                destroyOnClose={true}
            >
                <div style={{
                    height: "360px"
                }}>
                    <CmTree
                        treeData={treeData}
                        expandedKeys={expandedKeys}
                        showIcon={true}
                        checkedKeys={checkedKeys}
                        autoExpandParent={autoExpandParent}
                        checkStrictly={false}
                        checkable={true}
                        selectable={false}
                        onCheck={this.onCheck}
                        onExpand={this.onExpand}
                    />
                </div>
            </CmModal>
        );
    }

    handleCancel = () => {
        this.props.handleCancel();
    };

    handleOk = () => {
        const {checkedKeys, treeData} = this.state;
        const list = [];
        treeForEach(treeData, node => {
            const id = node.id;
            if (node.data.type == 2 && checkedKeys.includes(id)) {
                list.push(node.data.code);
            }
        });
        this.props.handleOk(list);
    };

    onCheck = c => {
        this.setState({
            checkedKeys: c
        });
    };

    onExpand = expandedKeys => {
        this.setState({
            expandedKeys,
            autoExpandParent: false
        });
    };

    setTreeData = () => {

        const {data} = this.props;
        const expandedKeys = [];
        this.request({
            url: "/cm-sites-sys/permission/classify/getTreeAndPermission",
            callBack: res => {
                let treeData = [res];
                treeForEach(treeData, node => {
                    if (node.type == 2) {
                        node.icon = <Icon type="control"/>;
                    } else {
                        if (!node.permissionAndTreeChild || node.permissionAndTreeChild.length === 0) {
                            node.disableCheckbox = true;
                            node.icon = <Icon style={{color: "#ffcd2c"}} type="folder" theme="filled"/>;
                        }
                    }
                }, "permissionAndTreeChild");
                treeData = generateTreeData(treeData, {
                    id: "id",
                    title: "name",
                    children: "permissionAndTreeChild",
                    key: "id"
                });

                treeForEach(treeData, node => {
                    if (node.children && node.children.length) {
                        expandedKeys.push(node.id);
                    }
                });
                let checkedKeys = [];
                if (data) {
                    checkedKeys = data.map(item => {
                        return item.id;
                    });
                }
                this.onExpand(expandedKeys);
                this.setState({
                    treeData,
                    checkedKeys
                });
            }
        });
    };
}
